import { createSlice } from "@reduxjs/toolkit";

/* Current month as 'YYYY-MM' (local time). */
const currentYm = () => {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${m}`;
};

/**
 * Payroll UI state ONLY. All data fetching happens via Apollo hooks in the
 * components — this slice never holds server data.
 */
const payrollSlice = createSlice({
  name: "payroll",
  initialState: {
    activeScreen: "dashboard", // dashboard | master | register | payslip | funds | reports | revision | settings
    ym: currentYm(),
    selectedEmpId: null, // Employee Master detail + Payslip + Revision selection
    reportTab: "pf", // pf | esi | pt | gratuity
  },
  reducers: {
    setActiveScreen: (state, action) => {
      state.activeScreen = action.payload;
    },
    setYm: (state, action) => {
      state.ym = action.payload;
    },
    setSelectedEmpId: (state, action) => {
      state.selectedEmpId = action.payload;
    },
    setReportTab: (state, action) => {
      state.reportTab = action.payload;
    },
  },
});

export const { setActiveScreen, setYm, setSelectedEmpId, setReportTab } =
  payrollSlice.actions;
export default payrollSlice.reducer;
